import Text from '@cartwhl/ui/base/TextNew';

export default function AssetLibraryNoResultsMessage() {
  return (
    <div className="flex flex-col items-center gap-1 p-14 text-center">
      <Text token="14" className="text-tertiary text-pretty">
        No matching results. Adjust your filters or try searching
      </Text>
    </div>
  );
}
